module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"errorHeading":"En feil har oppstått ved innlogging","errorDescription":"Siden fungerer ikke uten klient sertifikat."},"en":{"errorHeading":"Oh no! We weren\u0027t able to log you in","errorDescription":"This page does not work without client certificate."}}')
  delete Component.options._Ctor
}
